import { v4 } from 'uuid';

/**
 * See full documentation on Notion:
 * https://www.notion.so/landr/Convert-Integration-with-web-app-1db4e564d2644d3ca345c495b1c3caf4
 */
class ConvertExperimentLoader {
    constructor(windowObject) {
        this.experimentCallbacks = {};
        this.window = windowObject;
        if (this.window) {
            this.initialize();
        }
    }
    run() {
        var _a, _b;
        if (!this.window) {
            return;
        }
        if ((_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.convert_done) {
            (_b = this.window._conv_q) === null || _b === void 0 ? void 0 : _b.push(['run', 'true']);
        }
    }
    registerToExperimentUpdate(experimentId, callback) {
        var _a;
        if (!this.window) {
            return;
        }
        // Notify right away
        (_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.push([this.notifyCallbackForExperiment(experimentId, callback)]);
        // Store callback for later call using async handler
        const registrationId = v4();
        this.experimentCallbacks[registrationId] = {
            experimentId,
            callback,
        };
        return registrationId;
    }
    unregisterToExperiment(registrationId) {
        delete this.experimentCallbacks[registrationId];
    }
    initialize() {
        var _a;
        // Ensure we have a queue of events for first app loading
        // https://convert.elevio.help/en/articles/84994-react-redux-and-convert-experiences
        this.window._conv_q = this.window._conv_q || [];
        // As there is no way to unregister listeners. We should only register to `snippet.experiences_evaluated` in `initialize` method
        // and we will handle
        (_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.push({
            what: 'addListener',
            params: {
                event: 'snippet.experiences_evaluated',
                handler: () => {
                    const callbacksRegistered = Object.entries(this.experimentCallbacks);
                    callbacksRegistered.forEach(([_, callbackRegistered]) => {
                        this.notifyCallbackForExperiment(callbackRegistered.experimentId, callbackRegistered.callback);
                    });
                },
            },
        });
    }
    notifyCallbackForExperiment(experimentId, callback) {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.window.convert) === null || _a === void 0 ? void 0 : _a.currentData) === null || _b === void 0 ? void 0 : _b.experiments) &&
            ((_d = (_c = this.window.convert) === null || _c === void 0 ? void 0 : _c.currentData) === null || _d === void 0 ? void 0 : _d.experiments[experimentId])) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { variation_id, variation_name } = this.window.convert.currentData.experiments[experimentId];
            callback({
                variationId: variation_id.toString(),
                variationName: variation_name,
            });
        }
        else {
            callback(null);
        }
    }
}

export { ConvertExperimentLoader };
